import type { Release } from '../releases';

export default {
  id: '2026-11-02-roadmap-v2',
  at: '2026-11-02T04:12:00Z',
  title: '«Ход разработки» — по ТЗ v2.0: план до пилота, критерии приёмки и чаты',
  modules: ['roadmap'],
  items: [
    'Страница сверена с ТЗ v2.0 от 29.10.2026 и ускоренным календарём владельца от 31.10.2026: контрольные точки от старта работ 1.11 до решения о пилоте 21.12.2026, у каждой — прошла она, идёт или впереди.',
    'Критерии приёмки ПМ-01…ПМ-14 — со статусом из реестра требований, чатом, который их ведёт, и тем, что держит каждый.',
    'Шаги владельца, которые ещё не сделаны, — с номером шага и сроком; прошедший срок выделен.',
    'Этапы: 0–3 выложены, 4–13 идут одновременно по чатам — у каждого дата первой выкладки; этап «Серверы в Казахстане» заменён на «Пилот на Railway, передача и администрирование», серверы в РК отложены.',
    'В начале страницы — последняя выкладка с датой и названием: она обновляется сама с каждой записью «Что нового». Сводка показывает готовое и частичное отдельно по первой очереди.',
  ],
  why: 'Страница показывала план по редакции ТЗ от 17.10 и этап 3 как текущий, хотя работа идёт по ТЗ v2.0 и все разделы уже в работе; не было видно, сколько осталось до решения о пилоте и что ждёт владельца.',
  link: '/roadmap',
} satisfies Release;
